import { Component } from '@angular/core'
import { ToggleThemeService } from './toggle-theme.service';

@Component({
    selector: 'widget-theme-switcher',
    imports: [],
    templateUrl: './theme-switcher.widget.html',
    styleUrl: './theme-switcher.widget.scss'
})
export class ThemeSwitcherWidget {
    constructor(private _toggleThemeService: ToggleThemeService) {
    }

    ngOnInit(): void {
        this._toggleThemeService.initializeTheme()
    }

    toggleTheme() {
        this._toggleThemeService.toggleTheme()
    }

    toggleDirection() {
        this._toggleThemeService.toggleDirection();
    }
}
